<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="statusOdontogramaPlace.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  data-cy="description"
                />
                <small data-cy="v-description" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="statusOdontogramaPlace.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description"
                />
                <small data-cy="v-description" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Cor" label-for="v-color">
              <div class="d-flex align-items-center">
                <div
                  class="color-preview mr-2"
                  :style="{
                    backgroundColor: statusOdontogramaPlace.corHex || '#ffffff',
                    width: '30px',
                    height: '30px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                  }"
                ></div>
                <b-form-input
                  id="v-color"
                  v-model="statusOdontogramaPlace.corHex"
                  placeholder="#000000"
                  class="mr-2"
                  @click="showColorPicker = !showColorPicker"
                  readonly
                />
                <b-button
                  variant="outline-primary"
                  @click="showColorPicker = !showColorPicker"
                >
                  Selecionar Cor
                </b-button>
              </div>
              <div v-if="showColorPicker" class="color-picker-wrapper mt-2">
                <chrome-picker
                  :value="statusOdontogramaPlace.corHex"
                  @input="updateColor"
                />
              </div>
            </b-form-group>
          </b-col>

          <b-col v-if="statusOdontogramaPlace.id" cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="statusOdontogramaPlace.ativo"
                :checked="statusOdontogramaPlace.ativo"
                name="check-button"
                switch
                inline
              >
                {{ statusOdontogramaPlace.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              data-cy="save"
              @click="save"
            >
              Salvar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              variant="outline-secondary"
              data-cy="cancel"
              @click="cancel"
            >
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import { Chrome } from "vue-color";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("statusOdontogramaSettingsModule", {
      statusOdontograma: (state) => state.statusOdontograma,
    }),
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    "chrome-picker": Chrome,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: "Cadastro de Status do Odontograma",
      required,
      showColorPicker: false,
      statusOdontogramaPlace: {
        id: "",
        descricao: "",
        nome: "",
        corHex: "#000000",
        ativo: true,
      },
    };
  },
  mounted() {
    this.statusOdontogramaPlace = JSON.parse(
      JSON.stringify(this.statusOdontograma)
    );
  },
  methods: {
    updateColor(color) {
      this.statusOdontogramaPlace.corHex = color.hex;
    },
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("statusOdontogramaSettingsModule/reset");
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.statusOdontogramaPlace.id) {
            this.$store
              .dispatch(
                "statusOdontogramaSettingsModule/edit",
                this.statusOdontogramaPlace
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Editar",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              });
          } else {
            this.$store
              .dispatch(
                "statusOdontogramaSettingsModule/insertNew",
                this.statusOdontogramaPlace
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Inserir",
                    response.response.data.error
                  );
                  return;
                }
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$refs.form.reset();
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.showColorPicker = false;
      this.statusOdontogramaPlace = {
        id: "",
        descricao: "",
        nome: "",
        ativo: true,
      };
    },
  },
};
</script>
